<script lang="ts">
  /** The default screen: pick a client, log hours, see what you logged. */
  import ClientChips from '$lib/components/ClientChips.svelte';
  import QuickEntry from '$lib/components/QuickEntry.svelte';
  import EntryList from '$lib/components/EntryList.svelte';
  import TimerBar from '$lib/components/TimerBar.svelte';
  import { store } from '$lib/store.svelte';
  import { formatHours, toMonthKey, today } from '$shared/dates';

  let handoffHours = $state<number | undefined>(undefined);
  let handoffNotes = $state<string | undefined>(undefined);
  /** Bumped to remount QuickEntry with new seed values when the timer stops. */
  let prefillToken = $state(0);

  const monthHours = $derived.by(() => {
    const month = toMonthKey(today());
    return store.entries.filter((e) => e.month === month).reduce((sum, e) => sum + e.hours, 0);
  });
</script>

{#if !store.clients.length}
  <div class="card center stack">
    <h2>No clients yet</h2>
    <p class="muted">
      Add your first client and the app will create a spreadsheet for it in your Drive.
    </p>
    <a class="cta" href="#/clients">Add a client</a>
  </div>
{:else}
  <div class="stack">
    <ClientChips />

    <TimerBar
      onstop={(result) => {
        handoffHours = result.hours;
        handoffNotes = result.note;
        prefillToken += 1;
      }}
    />

    {#key prefillToken}
      <QuickEntry
        initialHours={handoffHours}
        initialNotes={handoffNotes}
        onlogged={() => {
          handoffHours = undefined;
          handoffNotes = undefined;
        }}
      />
    {/key}

    <div class="spread totals">
      <span class="muted">This month</span>
      <strong class="num">{formatHours(monthHours)}</strong>
    </div>

    <EntryList entries={store.entries} />
  </div>
{/if}

<style>
  .center {
    text-align: center;
  }

  .cta {
    display: inline-block;
    background: var(--accent);
    color: var(--accent-fg);
    text-decoration: none;
    font-weight: 650;
    border-radius: var(--radius);
    padding: 0.7rem 1.1rem;
    justify-self: center;
  }

  .totals {
    padding: 0 0.5rem;
    font-size: 0.95rem;
  }
</style>
